export const isInViewport = (element?: HTMLElement, bottom = 0) => {
  if (!element) return false;
  const rect = element.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom >= bottom;
};
